import { IOfferingContact } from './offering-contact';

export interface IOfferingContactsState {
    offeringId: number | null;
    contacts: IOfferingContact[];
    loading: boolean;
    saving: boolean;
    error: string | null;
}

export const initialOfferingContactsState: IOfferingContactsState = {
    offeringId: null,
    contacts: [],
    loading: false,
    saving: false,
    error: null,
};
